<nav class="navbar head-nav">
  <h2 *ngIf="enterpriseRequestsDetails">{{ "configurations.Registration Request Details" | translate }}</h2>
  <h2 *ngIf="enterpriseView">{{ "enterprises.Enterprises Details" | translate }}</h2>
  <h2 *ngIf="assistanceRequestView">{{ "AssistanceRequests.Assistance Request Details" | translate }}</h2>
  <h2 *ngIf="casesView">{{ "cases.Case Details" | translate }}</h2>

  <ol class="breadcrumb">
    <li class="breadcrumb-item"><a (click)="navigateToAdmin()">{{ "sections.Home" | translate }}</a></li>
    <li class="breadcrumb-item active" aria-current="page" *ngIf="enterpriseRequestsDetails">{{
      "configurations.Registration Request Details" | translate }}</li>
    <li class="breadcrumb-item active" aria-current="page" *ngIf="enterpriseView">{{ "enterprises.Enterprises" |
      translate }}</li>
    <li class="breadcrumb-item active" aria-current="page" *ngIf="assistanceRequestView">{{
      "AssistanceRequests.Assistance Request Details" | translate }}</li>
    <li class="breadcrumb-item active" aria-current="page" *ngIf="casesView">{{ "header.Cases" | translate }}</li>
  </ol>
</nav>

<div *ngIf="!dataSource && dataLoading" class="dataLoading">
  <mat-spinner class="m-auto" diameter="50"></mat-spinner>
</div>
<div *ngIf="dataSource && !dataLoading">
  <div *ngIf="dataSource; else dataEmpty" class="page project-details-page">
    <div class="row">
      <div class="col-12">
        <div class="bg-cover-header">
          <div class="request-title">
            <h3>
              <svg width="24" height="24" viewBox="0 0 24 24">
                <path id="user-enterprise-icon"
                  d="M-7671.047-101v-3a.7.7,0,0,0-.7-.7.7.7,0,0,0-.7.7v3h-1.594v-5.25A2.957,2.957,0,0,0-7677-109.2a2.956,2.956,0,0,0-2.953,2.953V-101h-1.594v-3a.7.7,0,0,0-.7-.7.7.7,0,0,0-.7.7v3h-2.344a.7.7,0,0,1-.7-.7V-124.3a.7.7,0,0,1,.7-.7h16.547a.7.7,0,0,1,.7.7v21.891h3.094V-104.8h-.844a.7.7,0,0,1-.7-.7v-5.25a2.241,2.241,0,0,1,2.25-2.2,2.242,2.242,0,0,1,2.25,2.2v5.25a.7.7,0,0,1-.7.7h-.844v2.391h.844a.7.7,0,0,1,.7.7.7.7,0,0,1-.7.7Zm-5.156-14.25v3a.7.7,0,0,0,.7.7h3.75a.7.7,0,0,0,.7-.7v-3a.7.7,0,0,0-.7-.7h-3.75A.7.7,0,0,0-7676.2-115.251Zm-6.75,0v3a.7.7,0,0,0,.7.7h3.75a.7.7,0,0,0,.7-.7v-3a.7.7,0,0,0-.7-.7h-3.75A.7.7,0,0,0-7682.954-115.251Zm6.75-6v3a.7.7,0,0,0,.7.7h3.75a.7.7,0,0,0,.7-.7v-3a.7.7,0,0,0-.7-.7h-3.75A.7.7,0,0,0-7676.2-121.251Zm-6.75,0v3a.7.7,0,0,0,.7.7h3.75a.7.7,0,0,0,.7-.7v-3a.7.7,0,0,0-.7-.7h-3.75A.7.7,0,0,0-7682.954-121.251Zm4.406,20.25v-5.25A1.549,1.549,0,0,1-7677-107.8a1.548,1.548,0,0,1,1.547,1.547V-101Zm3.75-11.953v-1.594h2.344v1.594Zm-6.75,0v-1.594h2.344v1.594Zm6.75-6v-1.594h2.344v1.594Zm-6.75,0v-1.594h2.344v1.594Z"
                  transform="translate(7686 125.001)" fill="#eff4f9" />
              </svg>{{dataSource.enterpriseName}}
              <small *ngIf="dataSource?.newEnterpriseName" [class.updated]="dataSource.enterpriseNameStatus == 1"
                [class.deleted]="dataSource.enterpriseNameStatus == 2"
                [class.added]="dataSource.enterpriseNameStatus == 3">
                ({{dataSource?.newEnterpriseName}})
              </small>

            </h3>
            <p *ngIf="!casesView && dataSource.registrationStatus != 0"><svg width="14" height="14.003" class="mr-1"
                viewBox="0 0 14 14.003">
                <path id="time-icon"
                  d="M-3490,8902a7.008,7.008,0,0,1,7-7,7.007,7.007,0,0,1,7,7,7.007,7.007,0,0,1-7,7A7.008,7.008,0,0,1-3490,8902Zm1.087,0a5.921,5.921,0,0,0,5.914,5.915,5.92,5.92,0,0,0,5.913-5.915,5.919,5.919,0,0,0-5.913-5.911A5.92,5.92,0,0,0-3488.913,8902Zm8.253,1.78-2.582-1.293a.54.54,0,0,1-.3-.487v-3.872a.542.542,0,0,1,.544-.544.542.542,0,0,1,.543.544v3.539l2.283,1.139a.548.548,0,0,1,.243.732.544.544,0,0,1-.489.3A.539.539,0,0,1-3480.66,8903.779Z"
                  transform="translate(3490 -8894.999)" fill="#fff" opacity="0.8" />
              </svg>{{ "matchmaking.Request Approved on" | translate }} : {{dataSource.registrationRespondDate | date:
              "MMM dd, y hh:mm aaa"}}</p>

            <p *ngIf="enterpriseRequestsDetails"><svg width="14" height="14.003" class="mr-1" viewBox="0 0 14 14.003">
                <path id="time-icon"
                  d="M-3490,8902a7.008,7.008,0,0,1,7-7,7.007,7.007,0,0,1,7,7,7.007,7.007,0,0,1-7,7A7.008,7.008,0,0,1-3490,8902Zm1.087,0a5.921,5.921,0,0,0,5.914,5.915,5.92,5.92,0,0,0,5.913-5.915,5.919,5.919,0,0,0-5.913-5.911A5.92,5.92,0,0,0-3488.913,8902Zm8.253,1.78-2.582-1.293a.54.54,0,0,1-.3-.487v-3.872a.542.542,0,0,1,.544-.544.542.542,0,0,1,.543.544v3.539l2.283,1.139a.548.548,0,0,1,.243.732.544.544,0,0,1-.489.3A.539.539,0,0,1-3480.66,8903.779Z"
                  transform="translate(3490 -8894.999)" fill="#fff" opacity="0.8" />
              </svg>
              {{ "enterprise.RequestedOn" | translate }} :
              {{dataSource.requestedOn | date: "MMM dd, y hh:mm aaa"}}</p>

            <p *ngIf="casesView"><svg width="14" height="14.003" class="mr-1" viewBox="0 0 14 14.003">
                <path id="time-icon"
                  d="M-3490,8902a7.008,7.008,0,0,1,7-7,7.007,7.007,0,0,1,7,7,7.007,7.007,0,0,1-7,7A7.008,7.008,0,0,1-3490,8902Zm1.087,0a5.921,5.921,0,0,0,5.914,5.915,5.92,5.92,0,0,0,5.913-5.915,5.919,5.919,0,0,0-5.913-5.911A5.92,5.92,0,0,0-3488.913,8902Zm8.253,1.78-2.582-1.293a.54.54,0,0,1-.3-.487v-3.872a.542.542,0,0,1,.544-.544.542.542,0,0,1,.543.544v3.539l2.283,1.139a.548.548,0,0,1,.243.732.544.544,0,0,1-.489.3A.539.539,0,0,1-3480.66,8903.779Z"
                  transform="translate(3490 -8894.999)" fill="#fff" opacity="0.8" />
              </svg>{{ "enterprise.Createdon" | translate }} : {{dataSource.createdOn | date: "MMMM dd, y hh:mm aaa"}}
            </p>
            <p *ngIf="casesView">
              <svg class="mx-projects-icon mr-1" width="10" height="14" viewBox="0 0 10 14">
                <path id="projects-icon"
                  d="M16086.871,18561.877a.444.444,0,0,1-.291-.418,4.382,4.382,0,0,0-1.379-3.164,5.03,5.03,0,0,1,3.518-8.283,4.92,4.92,0,0,1,3.719,1.367,5.048,5.048,0,0,1,.35,6.932,4.3,4.3,0,0,0-1.368,3.148.455.455,0,0,1-.306.424,2.121,2.121,0,1,1-4.242-.006Zm2.122,1.221a1.226,1.226,0,0,0,1.222-1.187h-2.441A1.226,1.226,0,0,0,16088.993,18563.1Zm.456-2.094h1.088a5.279,5.279,0,0,1,1.566-3.285,4.14,4.14,0,0,0-.285-5.682,4.073,4.073,0,0,0-3.049-1.123,4.125,4.125,0,0,0-2.885,6.791,5.381,5.381,0,0,1,1.577,3.3h1.088v-1.043l-.184.1a.484.484,0,0,1-.21.053.476.476,0,0,1-.207-.051l-.6-.445a.454.454,0,0,1,.42-.8l.383.336.632-.336a.057.057,0,0,1,.019,0,.42.42,0,0,1,.188-.047h0a.44.44,0,0,1,.192.047.033.033,0,0,1,.013,0l.637.336.44-.336a.454.454,0,0,1,.419.8l-.651.443a.451.451,0,0,1-.415,0l-.186-.1Zm-.8-2.914a.364.364,0,0,1-.36-.289l-.108-.473-.041-.012a3.073,3.073,0,0,1-.443-.186l-.041-.021-.407.258a.37.37,0,0,1-.463-.055l-.492-.5a.368.368,0,0,1-.053-.461l.257-.41-.021-.043a2.9,2.9,0,0,1-.184-.445l-.014-.041-.471-.107a.367.367,0,0,1-.288-.363v-.7a.364.364,0,0,1,.288-.363l.471-.109.014-.043a3.005,3.005,0,0,1,.184-.447l.021-.041-.257-.41a.372.372,0,0,1,.053-.461l.5-.5a.371.371,0,0,1,.46-.053l.407.262.041-.021a2.627,2.627,0,0,1,.443-.186l.043-.014.106-.473a.368.368,0,0,1,.36-.291h.7a.368.368,0,0,1,.36.291l.108.473.041.014a2.562,2.562,0,0,1,.443.186l.041.021.406-.258a.369.369,0,0,1,.461.049l.5.5a.376.376,0,0,1,.05.465l-.257.408.021.039a2.87,2.87,0,0,1,.184.447l.013.043.472.109a.368.368,0,0,1,.287.363v.7a.367.367,0,0,1-.29.363l-.469.107-.013.043a2.959,2.959,0,0,1-.184.443l-.021.043.257.41a.368.368,0,0,1-.052.461l-.5.5a.371.371,0,0,1-.458.051l-.409-.258-.041.021a3.119,3.119,0,0,1-.443.186l-.044.012-.105.473a.366.366,0,0,1-.36.289Zm-.8-1.734a2.014,2.014,0,0,0,.72.3.369.369,0,0,1,.285.287l.145.643.147-.646a.373.373,0,0,1,.282-.281,2.084,2.084,0,0,0,.721-.3.384.384,0,0,1,.442.025l.516.328-.342-.543-.008-.012a.367.367,0,0,1,0-.41,2,2,0,0,0,.3-.719.379.379,0,0,1,.283-.289l.643-.145-.643-.148a.372.372,0,0,1-.283-.283,1.972,1.972,0,0,0-.3-.725.381.381,0,0,1,.028-.449l.324-.516-.552.352a.353.353,0,0,1-.406,0,2.107,2.107,0,0,0-.718-.3.371.371,0,0,1-.285-.283l-.146-.646-.146.646a.373.373,0,0,1-.285.283,2.054,2.054,0,0,0-.718.3.372.372,0,0,1-.442-.025l-.513-.326.347.555a.367.367,0,0,1,0,.412,2.047,2.047,0,0,0-.3.717.374.374,0,0,1-.28.289l-.645.148.643.143a.373.373,0,0,1,.282.291,2.087,2.087,0,0,0,.3.719.385.385,0,0,1-.023.447l-.326.518.551-.354a.3.3,0,0,1,.194-.061A.4.4,0,0,1,16087.849,18556.355Zm-.639-1.762a1.789,1.789,0,1,1,1.79,1.795A1.8,1.8,0,0,1,16087.21,18554.594Zm.9,0a.887.887,0,1,0,.888-.895A.891.891,0,0,0,16088.112,18554.594Z"
                  transform="translate(-16083.999 -18550.002)" fill="#fff" opacity="0.8" />
              </svg>
              {{ "project.Project" | translate }} :
              <a (click)="navigateToProjectDetails(dataSource.project.id)">
                {{dataSource.project.name}}
                <svg width="12" height="12.001" viewBox="0 0 12 12.001">
                  <path id="external-link-icon"
                    d="M-2451.412-1881.187h-8.137a1.837,1.837,0,0,1-1.834-1.832v-8.14a2.016,2.016,0,0,1,1.844-2.028h3.949v1.241h-3.931a.626.626,0,0,0-.62.623l-.013,8.3a.605.605,0,0,0,.605.605l8.3-.013a.625.625,0,0,0,.621-.621v-3.93h1.242v3.931a2.019,2.019,0,0,1-2.02,1.862Zm-6.052-4.3a.614.614,0,0,1-.189-.457.59.59,0,0,1,.19-.416l5.863-5.6-1.3.008a.623.623,0,0,1-.623-.621.622.622,0,0,1,.621-.62h2.886a.614.614,0,0,1,.631.605v2.912a.622.622,0,0,1-.621.621.622.622,0,0,1-.621-.621l-.008-1.491-5.949,5.674a.645.645,0,0,1-.442.174A.634.634,0,0,1-2457.465-1885.485Z"
                    transform="translate(2461.384 1893.188)" fill="#D4F2FF" opacity="0.8"></path>
                </svg>
              </a>
            </p>
            <p
              *ngIf="!casesView && dataSource.assistanceRequestsDetails && dataSource.assistanceRequestsDetails.length">
              <svg class="mx-projects-icon mr-1" width="10" height="14" viewBox="0 0 10 14">
                <path id="projects-icon"
                  d="M16086.871,18561.877a.444.444,0,0,1-.291-.418,4.382,4.382,0,0,0-1.379-3.164,5.03,5.03,0,0,1,3.518-8.283,4.92,4.92,0,0,1,3.719,1.367,5.048,5.048,0,0,1,.35,6.932,4.3,4.3,0,0,0-1.368,3.148.455.455,0,0,1-.306.424,2.121,2.121,0,1,1-4.242-.006Zm2.122,1.221a1.226,1.226,0,0,0,1.222-1.187h-2.441A1.226,1.226,0,0,0,16088.993,18563.1Zm.456-2.094h1.088a5.279,5.279,0,0,1,1.566-3.285,4.14,4.14,0,0,0-.285-5.682,4.073,4.073,0,0,0-3.049-1.123,4.125,4.125,0,0,0-2.885,6.791,5.381,5.381,0,0,1,1.577,3.3h1.088v-1.043l-.184.1a.484.484,0,0,1-.21.053.476.476,0,0,1-.207-.051l-.6-.445a.454.454,0,0,1,.42-.8l.383.336.632-.336a.057.057,0,0,1,.019,0,.42.42,0,0,1,.188-.047h0a.44.44,0,0,1,.192.047.033.033,0,0,1,.013,0l.637.336.44-.336a.454.454,0,0,1,.419.8l-.651.443a.451.451,0,0,1-.415,0l-.186-.1Zm-.8-2.914a.364.364,0,0,1-.36-.289l-.108-.473-.041-.012a3.073,3.073,0,0,1-.443-.186l-.041-.021-.407.258a.37.37,0,0,1-.463-.055l-.492-.5a.368.368,0,0,1-.053-.461l.257-.41-.021-.043a2.9,2.9,0,0,1-.184-.445l-.014-.041-.471-.107a.367.367,0,0,1-.288-.363v-.7a.364.364,0,0,1,.288-.363l.471-.109.014-.043a3.005,3.005,0,0,1,.184-.447l.021-.041-.257-.41a.372.372,0,0,1,.053-.461l.5-.5a.371.371,0,0,1,.46-.053l.407.262.041-.021a2.627,2.627,0,0,1,.443-.186l.043-.014.106-.473a.368.368,0,0,1,.36-.291h.7a.368.368,0,0,1,.36.291l.108.473.041.014a2.562,2.562,0,0,1,.443.186l.041.021.406-.258a.369.369,0,0,1,.461.049l.5.5a.376.376,0,0,1,.05.465l-.257.408.021.039a2.87,2.87,0,0,1,.184.447l.013.043.472.109a.368.368,0,0,1,.287.363v.7a.367.367,0,0,1-.29.363l-.469.107-.013.043a2.959,2.959,0,0,1-.184.443l-.021.043.257.41a.368.368,0,0,1-.052.461l-.5.5a.371.371,0,0,1-.458.051l-.409-.258-.041.021a3.119,3.119,0,0,1-.443.186l-.044.012-.105.473a.366.366,0,0,1-.36.289Zm-.8-1.734a2.014,2.014,0,0,0,.72.3.369.369,0,0,1,.285.287l.145.643.147-.646a.373.373,0,0,1,.282-.281,2.084,2.084,0,0,0,.721-.3.384.384,0,0,1,.442.025l.516.328-.342-.543-.008-.012a.367.367,0,0,1,0-.41,2,2,0,0,0,.3-.719.379.379,0,0,1,.283-.289l.643-.145-.643-.148a.372.372,0,0,1-.283-.283,1.972,1.972,0,0,0-.3-.725.381.381,0,0,1,.028-.449l.324-.516-.552.352a.353.353,0,0,1-.406,0,2.107,2.107,0,0,0-.718-.3.371.371,0,0,1-.285-.283l-.146-.646-.146.646a.373.373,0,0,1-.285.283,2.054,2.054,0,0,0-.718.3.372.372,0,0,1-.442-.025l-.513-.326.347.555a.367.367,0,0,1,0,.412,2.047,2.047,0,0,0-.3.717.374.374,0,0,1-.28.289l-.645.148.643.143a.373.373,0,0,1,.282.291,2.087,2.087,0,0,0,.3.719.385.385,0,0,1-.023.447l-.326.518.551-.354a.3.3,0,0,1,.194-.061A.4.4,0,0,1,16087.849,18556.355Zm-.639-1.762a1.789,1.789,0,1,1,1.79,1.795A1.8,1.8,0,0,1,16087.21,18554.594Zm.9,0a.887.887,0,1,0,.888-.895A.891.891,0,0,0,16088.112,18554.594Z"
                  transform="translate(-16083.999 -18550.002)" fill="#fff" opacity="0.8" />
              </svg>
              {{ "project.Project" | translate }} :
              <a (click)="navigateToProjectDetails(dataSource.assistanceRequestsDetails[0].project.id)">
                {{dataSource.assistanceRequestsDetails[0].project.name}}
                <svg width="12" height="12.001" viewBox="0 0 12 12.001">
                  <path id="external-link-icon"
                    d="M-2451.412-1881.187h-8.137a1.837,1.837,0,0,1-1.834-1.832v-8.14a2.016,2.016,0,0,1,1.844-2.028h3.949v1.241h-3.931a.626.626,0,0,0-.62.623l-.013,8.3a.605.605,0,0,0,.605.605l8.3-.013a.625.625,0,0,0,.621-.621v-3.93h1.242v3.931a2.019,2.019,0,0,1-2.02,1.862Zm-6.052-4.3a.614.614,0,0,1-.189-.457.59.59,0,0,1,.19-.416l5.863-5.6-1.3.008a.623.623,0,0,1-.623-.621.622.622,0,0,1,.621-.62h2.886a.614.614,0,0,1,.631.605v2.912a.622.622,0,0,1-.621.621.622.622,0,0,1-.621-.621l-.008-1.491-5.949,5.674a.645.645,0,0,1-.442.174A.634.634,0,0,1-2457.465-1885.485Z"
                    transform="translate(2461.384 1893.188)" fill="#D4F2FF" opacity="0.8"></path>
                </svg>
              </a>
            </p>
          </div>

        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12 ">
        <div class="en-r-details">
          <div class="row">
            <div class="col-12">
              <div class="button-group-custom">
                <mat-button-toggle-group [(ngModel)]="tabCase" (change)="toggleTabs($event.value)">
                  <mat-button-toggle value="Request">
                    Request
                  </mat-button-toggle>
                  <mat-button-toggle value="AdditionalInfo">
                    {{ 'configurations.Additional Information' | translate }}
                  </mat-button-toggle>
                  <mat-button-toggle value="About">
                    About
                  </mat-button-toggle>
                  <mat-button-toggle value="Contact">
                    Contact
                  </mat-button-toggle>
                  <mat-button-toggle value="Applicant">
                    Applicant
                  </mat-button-toggle>
                  <mat-button-toggle value="Application" *ngIf="assistanceRequestView">
                    Application
                  </mat-button-toggle>
                </mat-button-toggle-group>
              </div>
            </div>
            <!--  'col-lg-8': dataSource.registrationStatus == 0 || dataSource.canSendRegistrationLink , 'col-12' : dataSource.registrationStatus != 0 && dataSource.canSendRegistrationLink == false  -->
            <div
              [ngClass]="dataSource.registrationStatus == 0 || dataSource.canSendRegistrationLink || (dataSource.registrationStatus == 1 && enterpriseView) || assistanceRequestView || casesView ? 'col-lg-8' : 'col-lg-12'">

              <div class="cards-container " *ngIf="enterpriseView && dataSource.canApproveProfileUpdates">
                <div class="first-card one-card project-details profile-expert-details guide-card-colors">
                  <div class="card-data-row mt-0">
                    <label class="text-secondary">Guide of updated content</label>
                  </div>
                  <ul class="expert-status-typy-colors mb-0">
                    <li class="d-inline-flex"><span class="added box"></span>{{ "experts.Added" | translate }}
                    </li>
                    <li class="d-inline-flex"><span class="updated box"></span>{{ "experts.Updated" | translate
                      }} </li>
                    <li class="d-inline-flex"><span class="deleted box"></span>{{ "experts.Deleted" | translate
                      }} </li>
                  </ul>
                </div>
              </div>

              <div id="Request" class="scroll-margin">
                <div class="cards-container questionnaires-details">
                  <div class="first-card one-card project-details">
                    <h5 class="card-title"> {{ "expert.RequestDetails" | translate }} </h5>
                    <div class="user-stauts mb-3" [hidden]="assistanceRequestView || enterpriseRequestsDetails">
                      <span *ngIf="dataSource.registrationStatus == enterpriseRegistrationStatus[0].value"
                        class="badge bg-success">{{enterpriseRegistrationStatus[0].name}}</span>
                      <span *ngIf="dataSource.registrationStatus == enterpriseRegistrationStatus[1].value"
                        class="badge bg-primary">{{enterpriseRegistrationStatus[1].name}}</span>
                      <span *ngIf="dataSource.registrationStatus == enterpriseRegistrationStatus[2].value"
                        class="badge bg-danger">{{enterpriseRegistrationStatus[2].name}}</span>
                      <i *ngIf="dataSource.registrationStatus == 0">{{ "experts.Waiting your decision" | translate
                        }}</i>
                    </div>

                    <div class="row p-description">
                      <div class="col-12 project-first-details p-0">
                        <label>{{ "enterprise.RequestedOn" | translate }}</label>
                        <p class="mb-0">{{casesView ? (dataSource.createdOn | date: "MMMM dd, y hh:mm aaa") :
                          (dataSource.requestedOn | date: "MMMM dd, y hh:mm aaa")}}</p>
                      </div>
                    </div>

                    <div class="row p-description" *ngIf="dataSource.registrationStatus == 1"
                      [hidden]="assistanceRequestView">
                      <div class="col-12 project-first-details p-0">
                        <label>{{ "experts.Joined on" | translate }} ( {{ "experts.Approved by" | translate }}
                          {{dataSource.registrationRespondByName}} )</label>
                        <p class="mb-0">{{dataSource.registrationRespondDate | date: "MMMM dd, y hh:mm aaa"}}</p>
                      </div>
                    </div>
                    <div class="row p-description" *ngIf="dataSource.registrationStatus == 2">
                      <div class="col-12 project-first-details p-0">
                        <label>{{ "experts.Rejection reason" | translate }}</label>
                        <p class="mb-0">{{dataSource.rejectionReason}}</p>
                      </div>
                    </div>
                    <ng-container
                      *ngIf="dataSource.assistanceRequestsDetails && dataSource.assistanceRequestsDetails.length">

                      <ng-container *ngIf="enterpriseRequestsDetails || assistanceRequestView || enterpriseView">
                        <div class="row p-description">
                          <div class="col-12 project-first-details p-0">
                            <label>{{ "project.Project" | translate }}</label>
                            <div>
                              <a (click)="navigateToProjectDetails(dataSource.assistanceRequestsDetails[0].project.id)"
                                class="external-link-icon">
                                <span class="ml-0"></span>
                                <svg width="12" height="12.001" viewBox="0 0 12 12.001">
                                  <path id="external-link-icon"
                                    d="M-2451.412-1881.187h-8.137a1.837,1.837,0,0,1-1.834-1.832v-8.14a2.016,2.016,0,0,1,1.844-2.028h3.949v1.241h-3.931a.626.626,0,0,0-.62.623l-.013,8.3a.605.605,0,0,0,.605.605l8.3-.013a.625.625,0,0,0,.621-.621v-3.93h1.242v3.931a2.019,2.019,0,0,1-2.02,1.862Zm-6.052-4.3a.614.614,0,0,1-.189-.457.59.59,0,0,1,.19-.416l5.863-5.6-1.3.008a.623.623,0,0,1-.623-.621.622.622,0,0,1,.621-.62h2.886a.614.614,0,0,1,.631.605v2.912a.622.622,0,0,1-.621.621.622.622,0,0,1-.621-.621l-.008-1.491-5.949,5.674a.645.645,0,0,1-.442.174A.634.634,0,0,1-2457.465-1885.485Z"
                                    transform="translate(2461.384 1893.188)" fill="#3e74b3" opacity="0.8"></path>
                                </svg>
                                {{dataSource.assistanceRequestsDetails[0].project.name}}
                              </a>
                            </div>
                          </div>
                        </div>
                        <ng-container *ngFor="let item of dataSource.assistanceRequestsDetails;let itemIndex = index">

                          <div class="card-data-row mt-2 mb-4" *ngIf="dataSource.assistanceRequestsDetails?.length > 1">
                            <span class="badge"> Assistance Request {{itemIndex + 1}}</span>
                          </div>
                          <div class="row p-description">
                            <div class="col-12 project-first-details p-0">
                              <label>{{ "expert.Sector" | translate }}</label>
                              <ul class="list-group">
                                <li class="list-group-item list-group-item-secondary">
                                  <div class="parents">
                                    <span *ngFor="let sector of item.projectSector.relatives">{{
                                      sector.name
                                      }}</span>
                                  </div>
                                  <div class="sector">
                                    <span class="badge">{{ item.projectSector.isicCode }}</span>
                                    <label>{{ item.projectSector.name }}</label>
                                  </div>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div class="row p-description">
                            <div class="col-12 project-first-details p-0">
                              <label>{{ "enterprises.AssistanceSpecialization" | translate }}</label>
                              <p>{{item.projectSpecialization.name}}</p>
                            </div>
                          </div>
                          <div class="row p-description">
                            <div class="col-12 project-first-details p-0">
                              <label>{{ "forms.DetailedAssistance" | translate }}</label>
                              <p>{{item.detailedRequiredAssistance}}</p>
                            </div>
                          </div>
                        </ng-container>
                      </ng-container>
                    </ng-container>
                    <ng-container *ngIf="casesView">
                      <div class="row p-description">
                        <div class="col-12 project-first-details p-0">
                          <label>{{ "project.Project" | translate }}</label>
                          <div>
                            <a (click)="navigateToProjectDetails(dataSource.project.id)" class="external-link-icon">
                              <span class="ml-0"></span>
                              <svg width="12" height="12.001" viewBox="0 0 12 12.001">
                                <path id="external-link-icon"
                                  d="M-2451.412-1881.187h-8.137a1.837,1.837,0,0,1-1.834-1.832v-8.14a2.016,2.016,0,0,1,1.844-2.028h3.949v1.241h-3.931a.626.626,0,0,0-.62.623l-.013,8.3a.605.605,0,0,0,.605.605l8.3-.013a.625.625,0,0,0,.621-.621v-3.93h1.242v3.931a2.019,2.019,0,0,1-2.02,1.862Zm-6.052-4.3a.614.614,0,0,1-.189-.457.59.59,0,0,1,.19-.416l5.863-5.6-1.3.008a.623.623,0,0,1-.623-.621.622.622,0,0,1,.621-.62h2.886a.614.614,0,0,1,.631.605v2.912a.622.622,0,0,1-.621.621.622.622,0,0,1-.621-.621l-.008-1.491-5.949,5.674a.645.645,0,0,1-.442.174A.634.634,0,0,1-2457.465-1885.485Z"
                                  transform="translate(2461.384 1893.188)" fill="#3e74b3" opacity="0.8"></path>
                              </svg>
                              {{dataSource.project.name}}
                            </a>
                          </div>
                        </div>
                      </div>
                      <div class="row p-description">
                        <div class="col-12 project-first-details p-0">
                          <label>{{ "expert.Sector" | translate }}</label>
                          <ul class="list-group">
                            <li class="list-group-item list-group-item-secondary">
                              <div class="parents">
                                <span *ngFor="let sector of dataSource.projectSector.relatives">{{
                                  sector.name
                                  }}</span>
                              </div>
                              <div class="sector">
                                <span class="badge">{{ dataSource.projectSector.isicCode }}</span>
                                <label>{{ dataSource.projectSector.name }}</label>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div class="row p-description">
                        <div class="col-12 project-first-details p-0">
                          <label>{{ "forms.DetailedAssistance" | translate }}</label>
                          <p>
                            {{dataSource.detailedRequiredAssistance}}
                          </p>
                        </div>
                      </div>

                      <div class="row p-description">
                        <div class="col-12 project-first-details p-0">
                          <label>{{ "enterprises.AssistanceSpecialization" | translate }}</label>
                          <p>{{dataSource.projectSpecialization.name}}</p>
                        </div>
                      </div>

                    </ng-container>
                    <div class="row p-description" *ngIf="attachments && attachments.length">
                      <div class="col-12 project-first-details p-0">
                        <label>{{ "expert.Attachments" | translate }} </label>
                        <div class="mt-3 mb-2" *ngIf="attachments && attachments.length">
                          <app-files-viewer [files]='attachments'></app-files-viewer>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div id="AdditionalInfo" class="scroll-margin">
                <div class="cards-container questionnaires">
                  <div class="first-card one-card project-details profile-expert-details">
                    <h5 class="card-title">{{ "configurations.Additional Information" | translate }}</h5>
                    <div class="questionnaire-box">
                      <mat-accordion class="example-headers-align">
                        <mat-expansion-panel class="mb-3"
                          *ngFor="let record of dataSource.additionalIfnoQuestionsAnswers; let i = index" hideToggle>
                          <mat-expansion-panel-header>
                            <mat-panel-title class="align-items-center">
                              <div class="d-flex align-items-center">
                                <span class="rounded"> {{i + 1}} </span>
                              </div>
                              <div class="d-flex align-items-center">
                                <p class="m-0" [class.updated]="record.changeType == 1"
                                  [class.deleted]="record.changeType == 2" [class.added]="record.changeType == 3">{{
                                  record.name}}</p>
                              </div>
                            </mat-panel-title>
                            <span class="material-icons open">
                              <svg width="15" height="15" viewBox="0 0 15 15">
                                <path id="expand-accordion-btn" d="M6.5,15V8.5H0v-2H6.5V0h2V6.5H15v2H8.5V15Z"
                                  fill="#7698ab" />
                              </svg>
                            </span>
                            <span class="material-icons close">
                              <svg width="15.001" height="2" viewBox="0 0 15.001 2">
                                <rect id="Rectangle_450" data-name="Rectangle 450" width="2" height="15.001"
                                  transform="translate(15.001) rotate(90)" fill="#7698ab" />
                              </svg></span>
                          </mat-expansion-panel-header>

                          <div>
                            <div class="row p-description pb-0">
                              <div class="col-12">
                                <label>{{ "enterprises.Answer" | translate }}</label>
                                <p class="mb-2">{{record.answer.text}}</p>
                              </div>
                            </div>
                          </div>
                        </mat-expansion-panel>

                      </mat-accordion>
                    </div>
                  </div>
                </div>
              </div>

              <div id="About" class="scroll-margin">
                <div class="cards-container">
                  <div class="first-card one-card project-details en-r-details-card">
                    <h5 class="card-title"> {{ "enterprises.About the Enterprise" | translate }} </h5>
                    <h6 class="company-name"> {{dataSource.enterpriseName}}
                      <small *ngIf="dataSource?.newEnterpriseName"
                        [class.updated]="dataSource.enterpriseNameStatus == 1"
                        [class.deleted]="dataSource.enterpriseNameStatus == 2"
                        [class.added]="dataSource.enterpriseNameStatus == 3">
                        ({{dataSource?.newEnterpriseName}})
                      </small>
                    </h6>
                    <p>
                      <a [href]="dataSource.website"
                        [class.updated]="dataSource.websiteStatus == 1 && !dataSource?.newWebsite" class="company-url"
                        target="_blank">{{dataSource?.website}}</a>
                    </p>
                    <p>
                      <a *ngIf="dataSource?.newWebsite" [class.updated]="dataSource.websiteStatus == 1"
                        [class.deleted]="dataSource.websiteStatus == 2" [class.added]="dataSource.websiteStatus == 3"
                        [href]="dataSource?.newWebsite">
                        {{dataSource?.newWebsite}}
                      </a>
                    </p>
                    <div class="card-data-row project-countries">
                      <label class="text-secondar">{{ "forms.Adress" | translate }}</label>

                      <p class="mb-1"><img [src]="dataSource?.country?.logoUrl" class="flag" alt="">
                        {{dataSource.country.name}},{{dataSource.city.name}}</p>

                      <p class="mb-1" *ngIf="dataSource?.newCity" [class.updated]="dataSource.cityStatus == 1"
                        [class.deleted]="dataSource.cityStatus == 2" [class.added]="dataSource.cityStatus == 3">
                        <img *ngIf="dataSource?.newCountry?.logoUrl" [src]="dataSource?.newCountry?.logoUrl"
                          class="flag" alt="">
                        <img *ngIf="!dataSource?.newCountry?.logoUrl" [src]="'./assets/images/empty-flag.png'"
                          class="flag" />
                        {{dataSource?.newCountry?.name}},{{dataSource?.newCity?.name}}
                      </p>

                      <p>{{dataSource.address}}</p>
                      <p *ngIf="dataSource?.newAddress" [class.updated]="dataSource.addressStatus == 1"
                        [class.deleted]="dataSource.addressStatus == 2" [class.added]="dataSource.addressStatus == 3">
                        {{dataSource?.newAddress}}
                      </p>
                    </div>
                    <div class="card-data-row project-countries">
                      <label class="text-secondar">{{ "forms.Tax-ID" | translate }}</label>
                      <p>{{ dataSource.registrationId}}</p>
                      <p *ngIf="dataSource?.newRegistrationId" [class.updated]="dataSource.registrationIdStatus == 1"
                        [class.deleted]="dataSource.registrationIdStatus == 2"
                        [class.added]="dataSource.registrationIdStatus == 3">
                        {{dataSource?.newRegistrationId}}
                      </p>

                    </div>
                    <div class="card-data-row project-countries">
                      <label class="text-secondar">
                        <!-- {{ "forms.Tax-ID" | translate }} -->
                        {{ "enterprises.Enterprise Size" | translate }}
                      </label>
                      <ul class="list-listed specializations">
                        <li *ngIf="dataSource.enterpriseSize == 0"> {{ "enterprises.Micro" | translate }}</li>
                        <li *ngIf="dataSource.enterpriseSize == 1"> {{ "enterprises.Small" | translate }}</li>
                        <li *ngIf="dataSource.enterpriseSize == 2"> {{ "enterprises.Medium" | translate }}</li>
                        <li *ngIf="dataSource.enterpriseSize == 3"> {{ "enterprises.Large" | translate }}</li>


                        <li> {{ dataSource.employeeNumber.name}} {{ "matchmaking.Employees" | translate }}</li>
                      </ul>
                      <ng-container *ngIf="dataSource.enterpriseSizeStatus">
                        <ul [class.updated]="dataSource.employeeNumberStatus == 1 || dataSource.enterpriseSizeStatus == 1"
                          [class.deleted]="dataSource.employeeNumberStatus == 2 || dataSource.enterpriseSizeStatus == 2"
                          [class.added]="dataSource.employeeNumberStatus == 3 || dataSource.enterpriseSizeStatus == 3"
                          class="list-listed specializations">
                          <li *ngIf="dataSource?.newEnterpriseSize == 0"> {{ "enterprises.Micro" | translate }}</li>
                          <li *ngIf="dataSource?.newEnterpriseSize == 1"> {{ "enterprises.Small" | translate }}</li>
                          <li *ngIf="dataSource?.newEnterpriseSize == 2"> {{ "enterprises.Medium" | translate }}</li>
                          <li *ngIf="dataSource?.newEnterpriseSize == 3"> {{ "enterprises.Large" | translate }}</li>
                          <li *ngIf="dataSource?.newEmployeeNumber"> {{ dataSource?.newEmployeeNumber?.name}} {{
                            "matchmaking.Employees" | translate }}</li>
                        </ul>
                      </ng-container>

                    </div>
                    <div class="card-data-row project-countries">
                      <label class="text-secondar">{{ "forms.ServicesProvided" | translate }}</label>
                      <ul class="list-listed specializations">
                        <li *ngFor="let service of dataSource.productAndServices"
                          [class.updated]="service.changeType == 1" [class.deleted]="service.changeType == 2"
                          [class.added]="service.changeType == 3"> {{service.name}} </li>
                      </ul>
                    </div>

                  </div>
                </div>
              </div>
              <div id="Contact" class="scroll-margin">
                <div class="cards-container">
                  <div class="first-card one-card project-details profile-expert-details">
                    <h5 class="card-title">{{ "expert.ContactInfo" | translate }}</h5>
                    <h6 class="company-name contact"> {{dataSource.contactPersonFullName}}
                      <span class="updated mx-2" *ngIf="dataSource?.newContactPersonName">
                        {{dataSource?.newContactPersonName}}
                      </span>
                    </h6>
                    <div class="card-data-row">
                      <label class="text-secondary">{{ "forms.Languages-Communication" | translate }}</label>
                      <ul class="languages">
                        <li *ngFor="let item of dataSource.languages" [class.updated]="item.changeType == 1"
                          [class.deleted]="item.changeType == 2" [class.added]="item.changeType == 3">
                          {{item.name}}
                        </li>
                      </ul>
                    </div>
                    <div class="card-data-row">
                      <label class="text-secondary">{{ "expert.Preferred-Methods" | translate }}</label>
                      <!-- <ng-container *ngIf="dataSource.canApproveProfileUpdates && enterpriseView">

                      </ng-container> -->
                      <ul class="contact-methods">
                        <li *ngFor="let item of dataSource.contactInfo" [class.updated]="item.changeType == 1"
                          [class.deleted]="item.changeType == 2" [class.added]="item.changeType == 3">
                          <label class="mr-1">{{item.name}} : </label>
                          <p *ngIf="item.name != 'Email'" [class.email]="item.name == 'Email'">{{item.phoneCode ?
                            item.phoneCode : ''}} {{item.value}}</p>
                          <a href="mailto:{{item.value}}" *ngIf="item.name == 'Email'" class="email"> {{item.value}}</a>
                        </li>
                      </ul>
                      <!-- <ul class="contact-methods updated" *ngIf="dataSource.oldContactInfo">
                        <li *ngFor="let item of dataSource.oldContactInfo">
                          <label class="mr-1">{{item.name}} : </label>
                          <p [class.email]="item.name == 'Email'">{{item.phoneCode ? item.phoneCode : ''}} {{item.value}}</p>
                        </li>
                      </ul> -->
                    </div>
                  </div>
                </div>
              </div>
              <div id="Applicant" class="scroll-margin">
                <div class="cards-container">
                  <div class="first-card one-card project-details profile-expert-details">
                    <h5 class="card-title">{{ "expert.Applicant-Info" | translate }}</h5>
                    <h6 class="company-name contact"> {{dataSource.applicantFullName}}
                      <span class="updated mx-2" *ngIf="dataSource?.newApplicantName">
                        {{dataSource?.newApplicantName}}
                      </span>
                    </h6>
                    <p class="en-r-position"> {{dataSource.position.name}} </p>
                    <p *ngIf="dataSource?.newPosition" [class.updated]="dataSource.positionStatus == 1"
                      [class.deleted]="dataSource.positionStatus == 2" [class.added]="dataSource.positionStatus == 3"
                      class="en-r-position"> {{dataSource?.newPosition?.name}} </p>
                    <div class="card-data-row">
                      <label class="text-secondary">{{ "expert.Email" | translate }}</label>
                      <ul class="contact-methods">
                        <li>
                          <a href="mailto:{{dataSource.applicantEmail}}"> {{dataSource.applicantEmail}}</a>
                        </li>
                        <li *ngIf="dataSource?.newApplicantEmail" [class.updated]="dataSource.applicantEmailStatus == 1"
                          [class.deleted]="dataSource.applicantEmailStatus == 2"
                          [class.added]="dataSource.applicantEmailStatus == 3">
                          <a href="mailto:{{dataSource?.newApplicantEmail}}"> {{dataSource?.newApplicantEmail}}</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

              </div>
              <div id="Application" class="scroll-margin" *ngIf="assistanceRequestView || casesView">
                <ng-container *ngIf="dataSource.application; else noApplication">
                  <div class="row">
                    <div class="col-12 application-details">
                      <div class="row">
                        <div class="col">
                          <h2>{{'AssistanceRequests.Application' | translate }}<span
                              class="badge">{{dataSource.application.title}}</span></h2>
                          <p>{{ "project.textApplications" | translate }}</p>
                        </div>
                      </div>
                      <div class="cards-container questionnaires">
                        <div class="first-card one-card project-details profile-expert-details">
                          <div class="row">
                            <div class="col">
                              <h5 class="card-title">{{ "project.General Questions" | translate }}</h5>
                            </div>
                            <div class="col text-right">
                              <a href="javascript:void(0)"
                                *ngIf="dataSource?.application.expertFeedbackedGeneralQuesions && dataSource?.status != assistanceRequestStatusEnum.NewCase"
                                (click)="otherExpertsFeedback('genral')" class="external-link-icon mr-3">
                                <span>{{ "AssistanceRequests.Expert's Feedback" | translate }}</span>
                                <svg width="14" height="14.001" viewBox="0 0 14 14.001">
                                  <path id="external-link-icon"
                                    d="M-2449.75-1879.186h-9.494a2.144,2.144,0,0,1-2.14-2.137v-9.5a2.353,2.353,0,0,1,2.152-2.365h4.607v1.448h-4.586a.73.73,0,0,0-.724.726l-.015,9.686a.706.706,0,0,0,.706.706l9.687-.016a.73.73,0,0,0,.724-.725v-4.585h1.448v4.585a2.356,2.356,0,0,1-2.356,2.172Zm-7.061-5.015a.718.718,0,0,1-.221-.534.687.687,0,0,1,.221-.485l6.841-6.528-1.516.01a.726.726,0,0,1-.726-.725.726.726,0,0,1,.725-.724h3.367a.716.716,0,0,1,.736.706v3.4a.726.726,0,0,1-.724.725.726.726,0,0,1-.725-.725l-.01-1.74-6.94,6.62a.752.752,0,0,1-.516.2A.742.742,0,0,1-2456.811-1884.2Z"
                                    transform="translate(2461.384 1893.187)" fill="#3e74b3" opacity="0.8" />
                                </svg>
                              </a>
                            </div>
                          </div>
                          <div class="questionnaire-box">
                            <mat-accordion class="example-headers-align">
                              <mat-expansion-panel class="mb-3"
                                *ngFor="let question of dataSource.application.gereralQuestionsAnswers; let i = index"
                                hideToggle>
                                <mat-expansion-panel-header>
                                  <mat-panel-title class="align-items-center">
                                    <div>
                                      <span class="rounded"> {{i + 1}} </span>
                                    </div>
                                    <div>
                                      <p class="mb-0">{{ question.name}}</p>
                                      <small>{{ question.questionType.name}}</small>
                                    </div>
                                  </mat-panel-title>
                                  <span class="material-icons open">
                                    <svg width="15" height="15" viewBox="0 0 15 15">
                                      <path id="expand-accordion-btn" d="M6.5,15V8.5H0v-2H6.5V0h2V6.5H15v2H8.5V15Z"
                                        fill="#7698ab" />
                                    </svg>
                                  </span>
                                  <span class="material-icons close">
                                    <svg width="15.001" height="2" viewBox="0 0 15.001 2">
                                      <rect id="Rectangle_450" data-name="Rectangle 450" width="2" height="15.001"
                                        transform="translate(15.001) rotate(90)" fill="#7698ab" />
                                    </svg></span>
                                </mat-expansion-panel-header>

                                <label class="mt-3">{{ "enterprises.Answer" | translate }}</label>
                                <div *ngFor="let answer of question.answers">
                                  <div class="row p-description pb-0 pt-0">
                                    <div class="col-12">
                                      <p class="mb-2">{{answer.text}}</p>
                                    </div>
                                  </div>
                                  <!-- <div class="row p-description pb-0" *ngFor="let item of answer.questions">
                                  <div class="col">
                                    <p class="mb-0"><i>{{item.name}}</i></p>
                                    <p *ngFor="let ans of item.answers">
                                      {{ans.name}}
                                    </p>
                                  </div>
                                </div> -->
                                </div>
                              </mat-expansion-panel>
                            </mat-accordion>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="cards-container questionnaires">
                        <div class="first-card one-card project-details profile-expert-details">
                          <h5 class="card-title">{{ "project.Key Performance Indicators (KPIs)" | translate }} <small>(
                              {{dataSource?.application.kpiYear}} )
                            </small></h5>
                          <div class="questionnaire-box" *ngFor="let group of dataSource?.application.kpIsWithAnswers;">
                            <div class="row">
                              <div class="col">
                                <h4>
                                  <span>
                                    {{group.name}}
                                  </span>
                                </h4>
                              </div>
                              <div class="col text-right">
                                <a href="javascript:void(0)"
                                  *ngIf="group.expertFeedbackedArea &&  dataSource?.status != assistanceRequestStatusEnum.NewCase"
                                  (click)="otherExpertsFeedback('KPIS' , group)" class="external-link-icon mr-3">
                                  <span>{{ "AssistanceRequests.Expert's Feedback" | translate }}</span>
                                  <svg width="14" height="14.001" viewBox="0 0 14 14.001">
                                    <path id="external-link-icon"
                                      d="M-2449.75-1879.186h-9.494a2.144,2.144,0,0,1-2.14-2.137v-9.5a2.353,2.353,0,0,1,2.152-2.365h4.607v1.448h-4.586a.73.73,0,0,0-.724.726l-.015,9.686a.706.706,0,0,0,.706.706l9.687-.016a.73.73,0,0,0,.724-.725v-4.585h1.448v4.585a2.356,2.356,0,0,1-2.356,2.172Zm-7.061-5.015a.718.718,0,0,1-.221-.534.687.687,0,0,1,.221-.485l6.841-6.528-1.516.01a.726.726,0,0,1-.726-.725.726.726,0,0,1,.725-.724h3.367a.716.716,0,0,1,.736.706v3.4a.726.726,0,0,1-.724.725.726.726,0,0,1-.725-.725l-.01-1.74-6.94,6.62a.752.752,0,0,1-.516.2A.742.742,0,0,1-2456.811-1884.2Z"
                                      transform="translate(2461.384 1893.187)" fill="#3e74b3" opacity="0.8" />
                                  </svg>
                                </a>
                              </div>
                            </div>
                            <mat-accordion class="example-headers-align">
                              <ng-container *ngFor="let kpi of group.kpis; let i = index">
                                <mat-expansion-panel class="mb-3" *ngFor="let question of kpi.questions;" hideToggle>
                                  <mat-expansion-panel-header>
                                    <mat-panel-title class="align-items-center">
                                      <div>
                                        <span class="rounded"> {{i + 1}} </span>
                                      </div>
                                      <div>
                                        <p class="mb-0">{{ kpi.name}}</p>
                                        <small>{{ question.name}}</small>
                                      </div>
                                    </mat-panel-title>
                                    <span class="material-icons open">
                                      <svg width="15" height="15" viewBox="0 0 15 15">
                                        <path id="expand-accordion-btn" d="M6.5,15V8.5H0v-2H6.5V0h2V6.5H15v2H8.5V15Z"
                                          fill="#7698ab" />
                                      </svg>
                                    </span>
                                    <span class="material-icons close">
                                      <svg width="15.001" height="2" viewBox="0 0 15.001 2">
                                        <rect id="Rectangle_450" data-name="Rectangle 450" width="2" height="15.001"
                                          transform="translate(15.001) rotate(90)" fill="#7698ab" />
                                      </svg></span>
                                  </mat-expansion-panel-header>

                                  <label class="mt-3">{{ "enterprises.Answer" | translate }}</label>
                                  <div *ngFor="let answer of question.answers">
                                    <div class="row p-description pb-0 pt-0">
                                      <div class="col-12">
                                        <p class="mb-2">{{answer.name}}</p>
                                      </div>
                                    </div>
                                    <div class="row p-description pb-0" *ngFor="let item of answer.questions">
                                      <div class="col">
                                        <p class="mb-0"><i>{{item.name}}</i></p>
                                        <p *ngFor="let ans of item.answers">
                                          {{ans.name}}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </mat-expansion-panel>
                              </ng-container>
                            </mat-accordion>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="cards-container questionnaires">
                        <div class="first-card one-card project-details profile-expert-details">
                          <h5 class="card-title">{{ "project.Other Questions" | translate }}</h5>
                          <div class="questionnaire-box"
                            *ngFor="let group of dataSource?.application.otherQuestionsWithAnswers;">
                            <div class="row">
                              <div class="col">
                                <h4>
                                  <span>
                                    {{group.group.name}}
                                  </span>
                                </h4>
                              </div>
                              <div class="col text-right">
                                <a href="javascript:void(0)"
                                  *ngIf="group.expertFeedbackedGroup && dataSource?.status != assistanceRequestStatusEnum.NewCase"
                                  (click)="otherExpertsFeedback('other' , group.group)" class="external-link-icon mr-3">
                                  <span>{{ "AssistanceRequests.Expert's Feedback" | translate }}</span>
                                  <svg width="14" height="14.001" viewBox="0 0 14 14.001">
                                    <path id="external-link-icon"
                                      d="M-2449.75-1879.186h-9.494a2.144,2.144,0,0,1-2.14-2.137v-9.5a2.353,2.353,0,0,1,2.152-2.365h4.607v1.448h-4.586a.73.73,0,0,0-.724.726l-.015,9.686a.706.706,0,0,0,.706.706l9.687-.016a.73.73,0,0,0,.724-.725v-4.585h1.448v4.585a2.356,2.356,0,0,1-2.356,2.172Zm-7.061-5.015a.718.718,0,0,1-.221-.534.687.687,0,0,1,.221-.485l6.841-6.528-1.516.01a.726.726,0,0,1-.726-.725.726.726,0,0,1,.725-.724h3.367a.716.716,0,0,1,.736.706v3.4a.726.726,0,0,1-.724.725.726.726,0,0,1-.725-.725l-.01-1.74-6.94,6.62a.752.752,0,0,1-.516.2A.742.742,0,0,1-2456.811-1884.2Z"
                                      transform="translate(2461.384 1893.187)" fill="#3e74b3" opacity="0.8" />
                                  </svg>
                                </a>
                              </div>
                            </div>
                            <mat-accordion class="example-headers-align">
                              <mat-expansion-panel class="mb-3" *ngFor="let question of group.questions; let i = index"
                                hideToggle>
                                <mat-expansion-panel-header>
                                  <mat-panel-title class="align-items-center">
                                    <div>
                                      <span class="rounded"> {{i + 1}} </span>
                                    </div>
                                    <div>
                                      <p class="mb-0">{{ question.questionText}}</p>
                                      <small>{{ question.questionType.name}}</small>
                                    </div>
                                  </mat-panel-title>
                                  <span class="material-icons open">
                                    <svg width="15" height="15" viewBox="0 0 15 15">
                                      <path id="expand-accordion-btn" d="M6.5,15V8.5H0v-2H6.5V0h2V6.5H15v2H8.5V15Z"
                                        fill="#7698ab" />
                                    </svg>
                                  </span>
                                  <span class="material-icons close">
                                    <svg width="15.001" height="2" viewBox="0 0 15.001 2">
                                      <rect id="Rectangle_450" data-name="Rectangle 450" width="2" height="15.001"
                                        transform="translate(15.001) rotate(90)" fill="#7698ab" />
                                    </svg></span>
                                </mat-expansion-panel-header>

                                <label class="mt-3">{{ "enterprises.Answer" | translate }}</label>
                                <div *ngFor="let answer of question.answers">
                                  <div class="row p-description pb-0 pt-0">
                                    <div class="col-12">
                                      <p class="mb-2">{{ question.questionType.name == 'Date' ? (answer.name | date:
                                        "MMM dd, y" ): answer.name}}</p>
                                    </div>
                                  </div>
                                  <div class="row p-description pb-0" *ngFor="let item of answer.questions">
                                    <div class="col">
                                      <p class="mb-0"><i>{{item.name}}</i></p>
                                      <p *ngFor="let ans of item.answers">
                                        {{ans.name}}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </mat-expansion-panel>
                            </mat-accordion>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-container>
                <ng-template #noApplication>
                  <div class="row">
                    <div class="col-12 answer-kpis">
                      <div class="cards-container">
                        <h5 class="card-title"> {{'AssistanceRequests.Application' | translate }} </h5>
                        <div class="first-card one-card project-details">
                          <div class="d-flex no-app">
                            <img src="./assets/images/application-illustration.png" class="img-fluid">
                            <div class="no-app-text">
                              <h4>{{"AssistanceRequests.Waiting for the Enterprise to submit their application" |
                                translate }}.</h4>
                              <p> {{'AssistanceRequests.text3' | translate }}.</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </div>
              <!-- <mat-tab label="Questionnaire">
                  <div class="cards-container questionnaires">
                    <div class="first-card one-card project-details profile-expert-details">
                      <h5 class="card-title">{{ "auth.enterpriseRegTitle5" | translate }}
                        <small>({{dataSource.questionnaire.title}})</small></h5>
                      <div class="questionnaire-box" *ngFor="let group of dataSource.questionnaire.groups;">
                        <div class="row">
                          <div class="col">
                            <h4>
                              <span>
                                {{group.group.name}}
                              </span>
                            </h4>
                          </div>
                          <div class="col text-right">
                            <a href="javascript:void(0)" *ngIf="group.currentExpertFeedback"
                              (click)="otherExpertsFeedback(group)" class="external-link-icon mr-3">
                              <span>{{ "requestes.Expert Feedback" | translate }}</span>
                              <svg width="14" height="14.001" viewBox="0 0 14 14.001">
                                <path id="external-link-icon"
                                  d="M-2449.75-1879.186h-9.494a2.144,2.144,0,0,1-2.14-2.137v-9.5a2.353,2.353,0,0,1,2.152-2.365h4.607v1.448h-4.586a.73.73,0,0,0-.724.726l-.015,9.686a.706.706,0,0,0,.706.706l9.687-.016a.73.73,0,0,0,.724-.725v-4.585h1.448v4.585a2.356,2.356,0,0,1-2.356,2.172Zm-7.061-5.015a.718.718,0,0,1-.221-.534.687.687,0,0,1,.221-.485l6.841-6.528-1.516.01a.726.726,0,0,1-.726-.725.726.726,0,0,1,.725-.724h3.367a.716.716,0,0,1,.736.706v3.4a.726.726,0,0,1-.724.725.726.726,0,0,1-.725-.725l-.01-1.74-6.94,6.62a.752.752,0,0,1-.516.2A.742.742,0,0,1-2456.811-1884.2Z"
                                  transform="translate(2461.384 1893.187)" fill="#3e74b3" opacity="0.8" />
                              </svg>
                            </a>
                          </div>
                        </div>
                        <mat-accordion class="example-headers-align">
                          <mat-expansion-panel class="mb-3" *ngFor="let question of group.questions; let i = index"
                            hideToggle>
                            <mat-expansion-panel-header>
                              <mat-panel-title class="align-items-center">
                                <div>
                                  <span class="rounded"> {{i + 1}} </span>
                                </div>
                                <div>
                                  <p>{{ question.questionText}}</p>
                                  <small>{{ question.questionType.name}}</small>
                                </div>
                              </mat-panel-title>
                              <span class="material-icons open">
                                <svg width="15" height="15" viewBox="0 0 15 15">
                                  <path id="expand-accordion-btn" d="M6.5,15V8.5H0v-2H6.5V0h2V6.5H15v2H8.5V15Z"
                                    fill="#7698ab" />
                                </svg>
                              </span>
                              <span class="material-icons close">
                                <svg width="15.001" height="2" viewBox="0 0 15.001 2">
                                  <rect id="Rectangle_450" data-name="Rectangle 450" width="2" height="15.001"
                                    transform="translate(15.001) rotate(90)" fill="#7698ab" />
                                </svg></span>
                            </mat-expansion-panel-header>

                            <div>
                              <div class="row p-description pb-0">
                                <div class="col-12">
                                  <label>{{ "enterprises.Answer" | translate }}</label>
                                  <p class="mb-2" *ngFor="let answer of question.answers">{{answer.name}}</p>
                                </div>
                              </div>
                            </div>
                          </mat-expansion-panel>

                        </mat-accordion>
                      </div>
                    </div>
                  </div>
                </mat-tab> -->
              <!-- <div id="KPIs" class="scroll-margin"
                *ngIf="!enterpriseView && !enterpriseRequestsDetails && !assistanceRequestView">
                <div class="cards-container questionnaires">
                  <div class="first-card one-card project-details profile-expert-details">
                    <h5 class="card-title">{{ "matchmaking.Key Performance Indicators (KPIs)" | translate }}
                      <small>({{dataSource.kpiYear}})</small>
                    </h5>
                    <div class="questionnaire-box" *ngFor="let group of dataSource.kpis;">
                      <h4>
                        <span>
                          {{group.name}}
                        </span>
                      </h4>
                      <mat-accordion class="example-headers-align">
                        <ng-container *ngFor="let kpi of group.kpis; let i = index">
                          <mat-expansion-panel class="mb-3" *ngFor="let question of kpi.questions;" hideToggle>

                            <mat-expansion-panel-header>
                              <mat-panel-title class="align-items-center">
                                <div>
                                  <span class="rounded"> {{i + 1}} </span>
                                </div>
                                <div>
                                  <p>{{ kpi.name}}</p>
                                  <small>{{ question.name}}</small>
                                </div>
                              </mat-panel-title>
                              <span class="material-icons open">
                                <svg width="15" height="15" viewBox="0 0 15 15">
                                  <path id="expand-accordion-btn" d="M6.5,15V8.5H0v-2H6.5V0h2V6.5H15v2H8.5V15Z"
                                    fill="#7698ab" />
                                </svg>
                              </span>
                              <span class="material-icons close">
                                <svg width="15.001" height="2" viewBox="0 0 15.001 2">
                                  <rect id="Rectangle_450" data-name="Rectangle 450" width="2" height="15.001"
                                    transform="translate(15.001) rotate(90)" fill="#7698ab" />
                                </svg></span>
                            </mat-expansion-panel-header>

                            <div *ngFor="let answer of question.answers">
                              <div class="row p-description pb-0">
                                <div class="col-12">
                                  <label>{{ "enterprises.Answer" | translate }}</label>
                                  <p class="mb-2">{{answer.name}}</p>
                                </div>
                              </div>
                              <div class="row p-description pb-0" *ngFor="let item of answer.questions">
                                <div class="col">
                                  <p class="mb-0"><i>{{item.name}}</i></p>
                                  <p *ngFor="let ans of item.answers">
                                    {{ans.name}}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </mat-expansion-panel>
                        </ng-container>

                      </mat-accordion>
                    </div>
                  </div>
                </div>
              </div> -->
              <div id="capturedImages" class="scroll-margin"
                *ngIf="!enterpriseView && !enterpriseRequestsDetails && !assistanceRequestView">
                <div class="cards-container questionnaires">
                  <div class="first-card one-card project-details profile-expert-details">
                    <h5 class="card-title">Captured Images <small>(contains marks and annotations)</small></h5>
                    <div class="captured-images" *ngIf="listCapturedImages.length; else dataEmpty">
                      <p>{{ "AssistanceRequests.Click on the image to show it in the viewer." | translate }}</p>
                      <div class="table-container mat-elevation-z8">
                        <div class="table-responsive">
                          <table class="table">
                            <thead>
                              <tr class="mat-header-row">
                                <th class="mat-header-cell">{{ "requestes.Image" | translate }}</th>
                                <th class="mat-header-cell">{{ "requestes.Captured by" | translate }}</th>
                                <th class="mat-header-cell">{{ "requestes.Uploaded on" | translate }}</th>
                                <th class="mat-header-cell">
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr class="mat-row mat-row-hover" *ngFor="let ele of listCapturedImages">
                                <td class="mat-cell">
                                  <div class="viewr-label" [matTooltip]="ele.title">
                                    <img class="rounded img-sm mr-2" [src]="ele.path" />
                                    {{ele.title}}
                                  </div>
                                </td>
                                <td class="mat-cell">
                                  <div class="d-flex align-items-center">
                                    <div class="img-cricle">
                                      <div class="image">
                                        <span>{{ ele.capturedBy | shortName }}</span>
                                      </div>
                                      <div class="image-label" [matTooltip]="ele.capturedBy">
                                        {{ele.capturedBy}}
                                      </div>
                                    </div>
                                  </div>
                                </td>
                                <td class="mat-cell">{{ele.uploadedOn | date: "MMM dd, y hh:mm aaa" }}</td>
                                <td class="mat-cell mat-column-tableOptions">
                                  <div>
                                    <a mat-icon-button matTooltip="Show on Viewer" matTooltipClass="allow-cr"
                                      (click)="openViewer(ele.imageId)">
                                      <svg width="20" height="13" viewBox="0 0 20 13">
                                        <path id="view-icon"
                                          d="M.129,6.9a.676.676,0,0,1,0-.794C.307,5.852,4.564,0,10,0s9.694,5.853,9.872,6.1a.677.677,0,0,1,0,.794C19.694,7.146,15.436,13,10,13S.307,7.146.129,6.9ZM1.5,6.5c1.027,1.27,4.494,5.152,8.5,5.152S17.477,7.77,18.5,6.5C17.474,5.229,14,1.344,10,1.344S2.524,5.227,1.5,6.5Zm4.545,0a3.956,3.956,0,1,1,7.911,0,3.956,3.956,0,1,1-7.911,0Zm1.317,0A2.639,2.639,0,1,0,10,3.811,2.668,2.668,0,0,0,7.362,6.5Z"
                                          transform="translate(0 0.001)" fill="#788da5" />
                                      </svg>
                                    </a>
                                    <a mat-icon-button *ngIf="ele.canDelete">
                                      <svg width="16" height="20.001" viewBox="0 0 16 20.001">
                                        <path id="delete-icon"
                                          d="M442.031,477.64a1.857,1.857,0,0,1-1.844-1.786l-.532-11.339h-.337a.62.62,0,0,1-.615-.625h0V461.7a1.553,1.553,0,0,1,1.539-1.562h3.384v-.625a1.863,1.863,0,0,1,1.846-1.875h2.461a1.863,1.863,0,0,1,1.846,1.875v.625h3.385A1.551,1.551,0,0,1,454.7,461.7v2.188a.62.62,0,0,1-.615.625h-.336l-.532,11.339a1.857,1.857,0,0,1-1.844,1.786Zm-.614-1.845a.619.619,0,0,0,.614.6h9.344a.619.619,0,0,0,.614-.6l.53-11.28H440.888ZM439.935,461.7v1.563h13.537V461.7a.31.31,0,0,0-.307-.312H440.242a.31.31,0,0,0-.307.31Zm4.923-2.187v.625h3.691v-.625a.62.62,0,0,0-.615-.625h-2.461a.621.621,0,0,0-.614.624Zm4.307,15v-8.125a.615.615,0,1,1,1.231,0v8.125a.615.615,0,1,1-1.231,0Zm-3.077,0v-8.125a.615.615,0,1,1,1.231,0v8.125a.615.615,0,1,1-1.231,0Zm-3.077,0v-8.125a.615.615,0,1,1,1.231,0v8.125a.615.615,0,1,1-1.231,0Z"
                                          transform="translate(-438.703 -457.641)" fill="#788da5" />
                                      </svg>
                                    </a>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <div class="pagination-container">
                            <div class="page-filter" *ngIf="pageCount > 1">
                              <span>{{ 'expert.page' | translate }}</span><input type="text"
                                (change)="updatePage($event)" [value]="manualPage" />/{{ pageCount }}
                            </div>
                            <mat-paginator class="mt-0 mb-3" #paginator *ngIf="pageCount > 1"
                              [length]="filterModel.totalCount" [pageSize]="filterModel.pageSize"
                              [pageSizeOptions]="[5, 10, 20]" (page)="getListCapturedImages($event)"
                              [pageIndex]="filterModel.pageNumber" showFirstLastButtons>
                            </mat-paginator>
                          </div>
                        </div>
                      </div>
                    </div>
                    <ng-template #dataEmpty>
                      <div class="no-captured-images text-center">
                        <img class="img-fluid" alt="Captured Images"
                          src="../../../assets/images/no-images-illustration.png" />
                        <p>There are no captured images uploaded!</p>
                      </div>
                    </ng-template>
                  </div>
                </div>
              </div>

            </div>
            <div class="col-lg-3"
              *ngIf="(dataSource.registrationStatus == 0 || dataSource.assistanceRequestStatus == assistanceRequestStatusEnum.New) || (enterpriseView && dataSource.canApproveProfileUpdates)">
              <div class="cards-container en-r-decision">
                <div class="first-card one-card project-details profile">
                  <div class="decision bg-white">
                    <div class="row">
                      <div class="col-12 text-center">
                        <h5>{{ "enterprises.What's your decision about this request?" | translate }}</h5>
                      </div>
                      <div class="col-12 text-center">
                        <button mat-raised-button
                          (click)="enterpriseView ? Decision(true , 'enterprise') : Decision(true) " color="success"
                          [class.loading-btn]="loading" [disabled]="loading">{{ "expert.Accept" |
                          translate
                          }}</button>
                        <button mat-raised-button
                          (click)="enterpriseView ? Decision(false , 'enterprise') : Decision(false)" color="danger">{{
                          "expert.Decline" |
                          translate
                          }}</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-3"
              *ngIf="dataSource.registrationStatus == 1 && enterpriseView && (dataSource.canEdit || dataSource.canDelete) && !dataSource.canApproveProfileUpdates">
              <div class="cards-container en-r-decision">
                <div class="first-card one-card project-details profile">
                  <div class="decision bg-white">
                    <div class="row">
                      <div class="col-12 text-center">
                        <h5>{{ "project.Available Actions" | translate }}</h5>
                      </div>
                      <div class="col-12 actions">
                        <button mat-raised-button (click)="openEnterpriseFormDialog(dataSource.id)" class="w-100"
                          color="primary" *ngIf="dataSource.canEdit">
                          <svg width="15" height="15" viewBox="0 0 20 20">
                            <path id="edit-icon"
                              d="M477.64,460.879l-1.477-1.474a2.84,2.84,0,0,0-3.993,0l-11.2,11.208-.2.268-.076.3-2.191,6.554a.636.636,0,0,0,.394.812.464.464,0,0,0,.21.034.413.413,0,0,0,.2-.027l6.888-2.293.011.005.1-.066.181-.008-.05-.1,11.209-11.22A2.838,2.838,0,0,0,477.64,460.879Zm-17.527,16.044,1.553-4.636,3.09,3.087Zm5.838-2.168-3.657-3.654,9.361-9.36,3.657,3.655Zm10.916-10.932,0,.014-.64.648-3.661-3.658.513-.514a1.547,1.547,0,0,1,2.177,0l1.49,1.48A1.542,1.542,0,0,1,476.866,463.823Z"
                              transform="translate(-458.462 -458.585)" fill="#fff" />
                          </svg>{{ "general.Edit" | translate }}
                        </button>
                        <button mat-raised-button (click)="removeEnterprise(dataSource.id)"
                          class="btn-outline-danger w-100" *ngIf="dataSource.canDelete" color="outline">
                          <svg width="14" height="17" viewBox="0 0 16 20.001">
                            <path id="delete-icon"
                              d="M442.031,477.64a1.857,1.857,0,0,1-1.844-1.786l-.532-11.339h-.337a.62.62,0,0,1-.615-.625h0V461.7a1.553,1.553,0,0,1,1.539-1.562h3.384v-.625a1.863,1.863,0,0,1,1.846-1.875h2.461a1.863,1.863,0,0,1,1.846,1.875v.625h3.385A1.551,1.551,0,0,1,454.7,461.7v2.188a.62.62,0,0,1-.615.625h-.336l-.532,11.339a1.857,1.857,0,0,1-1.844,1.786Zm-.614-1.845a.619.619,0,0,0,.614.6h9.344a.619.619,0,0,0,.614-.6l.53-11.28H440.888ZM439.935,461.7v1.563h13.537V461.7a.31.31,0,0,0-.307-.312H440.242a.31.31,0,0,0-.307.31Zm4.923-2.187v.625h3.691v-.625a.62.62,0,0,0-.615-.625h-2.461a.621.621,0,0,0-.614.624Zm4.307,15v-8.125a.615.615,0,1,1,1.231,0v8.125a.615.615,0,1,1-1.231,0Zm-3.077,0v-8.125a.615.615,0,1,1,1.231,0v8.125a.615.615,0,1,1-1.231,0Zm-3.077,0v-8.125a.615.615,0,1,1,1.231,0v8.125a.615.615,0,1,1-1.231,0Z"
                              transform="translate(-438.703 -457.641)" fill="#FF3B30" />
                          </svg>{{ "experts.Delete" | translate }} </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-3" *ngIf="dataSource.canSendRegistrationLink">
              <div class="cards-container en-r-decision">
                <div class="first-card one-card project-details profile">
                  <div class="decision bg-white">
                    <div class="row">
                      <div class="col-12 text-center">
                        <h5>{{ "enterprises.resendText" | translate }}</h5>
                      </div>
                      <!-- <div class="col-12 text-center">
                        <button mat-raised-button (click)="SendRegistrationLink(dataSource.id)"
                          [class.loading-btn]="loading" [disabled]="loading" color="success">{{ "enterprises.Resend Link" | translate }}</button>
                      </div> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-3"
              *ngIf="assistanceRequestView && dataSource.assistanceRequestStatus != assistanceRequestStatusEnum.New">
              <ng-container
                *ngIf="dataSource.assistanceRequestStatus != 1 && dataSource.assistanceRequestStatus != assistanceRequestStatusEnum.FBApproved; else elseDiv">
                <div class="cards-container en-r-decision">
                  <div class="first-card one-card project-details profile mb-0" *ngIf="dataSource.canAssign">
                    <div class="row">
                      <div class="col-12 text-center assigned-stauts ">
                        <span *ngIf="dataSource.assistanceRequestStatus == assistanceRequestStatusEnum.New"
                          class="badge bg-success">
                          {{ "experts.New" | translate }}
                        </span>
                        <span *ngIf="dataSource.assistanceRequestStatus == assistanceRequestStatusEnum.FBApproved"
                          class="badge bg-primary">
                          {{ "AssistanceRequests.Waiting Enterprise Application" |translate }}
                        </span>
                        <span *ngIf="dataSource.assistanceRequestStatus == assistanceRequestStatusEnum.FBRejected"
                          class="badge bg-danger">
                          {{ "experts.Declined" | translate}}
                        </span>
                        <span
                          *ngIf="dataSource.assistanceRequestStatus == assistanceRequestStatusEnum.EnterpriseFilledApplication"
                          class="badge bg-warning">
                          {{ "AssistanceRequests.Waiting to Assign Expert" | translate}}
                        </span>
                        <span *ngIf="dataSource.assistanceRequestStatus == assistanceRequestStatusEnum.ExpertAssigned"
                          class="badge bg-primary">
                          {{ "general.Expert" | translate}} {{ "experts.Assigned" | translate}}
                        </span>
                        <span *ngIf="dataSource.assistanceRequestStatus ==  assistanceRequestStatusEnum.ExpertDeclined "
                          class="badge bg-danger">
                          {{ "AssistanceRequests.Expert Declined" | translate}}
                        </span>
                        <span *ngIf="dataSource.assistanceRequestStatus ==  assistanceRequestStatusEnum.ExpertWithdrawn"
                          class="badge bg-warning">
                          {{ "AssistanceRequests.Expert Withdrawn" | translate}}
                        </span>
                        <span *ngIf="dataSource.assistanceRequestStatus == assistanceRequestStatusEnum.NewCase"
                          class="badge bg-success">
                          {{ "AssistanceRequests.New Case" | translate }}
                        </span>
                        <span
                          *ngIf="dataSource.assistanceRequestStatus == assistanceRequestStatusEnum.ExpertAddedFeedback"
                          class="badge bg-primary">
                          {{ "AssistanceRequests.Expert Added Feedback" | translate}}
                        </span>
                        <span
                          *ngIf="dataSource.assistanceRequestStatus == assistanceRequestStatusEnum.EnterpriseAddedFeedback"
                          class="badge bg-primary">
                          {{ "AssistanceRequests.Enterprise Added Feedback" | translate}}
                        </span>
                        <span
                          *ngIf="dataSource.assistanceRequestStatus == assistanceRequestStatusEnum.FocalPointAddedFeedbachAndClose"
                          class="badge bg-danger">
                          {{ "AssistanceRequests.Request Closed" | translate}}
                        </span>
                      </div>
                      <div class="col-12 text-center assigned-title">
                        <h5>{{ "matchmaking.Assigned Expert" | translate }}</h5>
                      </div>
                    </div>
                    <div class="decision bg-white">
                      <div class="row">

                        <div class="col-12 text-center">
                          <img class="img-fluid" src="../../../assets/images/no-expert-assigned-illustration.png"
                            alt="">
                        </div>
                        <div class="col-12 text-center">
                          <button mat-raised-button class="btn" color="primary" [class.loading-btn]="loading"
                            [disabled]="loading" (click)="assignExpert(dataSource)">
                            <span> {{ "matchmaking.Assign Expert" | translate}}</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="first-card one-card project-details profile mb-0" *ngIf="dataSource.canReassign">
                    <div class="row mb-0">

                      <div class="col-12 text-center assigned-stauts ">
                        <span *ngIf="dataSource.assistanceRequestStatus == assistanceRequestStatusEnum.New"
                          class="badge bg-success">
                          {{ "experts.New" | translate }}
                        </span>
                        <span *ngIf="dataSource.assistanceRequestStatus == assistanceRequestStatusEnum.FBApproved"
                          class="badge bg-primary">
                          {{ "AssistanceRequests.Waiting Enterprise Application" |translate }}
                        </span>
                        <span *ngIf="dataSource.assistanceRequestStatus == assistanceRequestStatusEnum.FBRejected"
                          class="badge bg-danger">
                          {{ "experts.Declined" | translate}}
                        </span>
                        <span
                          *ngIf="dataSource.assistanceRequestStatus == assistanceRequestStatusEnum.EnterpriseFilledApplication"
                          class="badge bg-warning">
                          {{ "AssistanceRequests.Waiting to Assign Expert" | translate}}
                        </span>
                        <span *ngIf="dataSource.assistanceRequestStatus == assistanceRequestStatusEnum.ExpertAssigned"
                          class="badge bg-assigned">
                          {{ "general.Expert" | translate}} {{ "experts.Assigned" | translate}}
                        </span>
                        <span *ngIf="dataSource.assistanceRequestStatus ==  assistanceRequestStatusEnum.ExpertDeclined "
                          class="badge bg-danger">
                          {{ "AssistanceRequests.Expert Declined" | translate}}
                        </span>
                        <span *ngIf="dataSource.assistanceRequestStatus ==  assistanceRequestStatusEnum.ExpertWithdrawn"
                          class="badge bg-warning">
                          {{ "AssistanceRequests.Expert Withdrawn" | translate}}
                        </span>
                        <span *ngIf="dataSource.assistanceRequestStatus == assistanceRequestStatusEnum.NewCase"
                          class="badge bg-success">
                          {{ "AssistanceRequests.New Case" | translate }}
                        </span>
                        <span
                          *ngIf="dataSource.assistanceRequestStatus == assistanceRequestStatusEnum.ExpertAddedFeedback"
                          class="badge bg-primary">
                          {{ "AssistanceRequests.Expert Added Feedback" | translate}}
                        </span>
                        <span
                          *ngIf="dataSource.assistanceRequestStatus == assistanceRequestStatusEnum.EnterpriseAddedFeedback"
                          class="badge bg-primary">
                          {{ "AssistanceRequests.Enterprise Added Feedback" | translate}}
                        </span>
                        <span
                          *ngIf="dataSource.assistanceRequestStatus == assistanceRequestStatusEnum.FocalPointAddedFeedbachAndClose"
                          class="badge bg-default">
                          {{ "AssistanceRequests.Request Closed" | translate}}
                        </span>
                      </div>
                      <div class="col-12 text-center assigned-title">
                        <h5>{{ "matchmaking.Assigned Expert" | translate }}</h5>
                      </div>
                    </div>
                    <div class="decision bg-white">
                      <div class="row">
                        <div class="col-12 text-center expert-data">
                          <div class="img-cricle">
                            <div class="image">
                              <span>{{ dataSource.expert.name | shortName }}</span>
                            </div>
                          </div>
                          <p class="name">{{dataSource.expert.name}}</p>
                          <p class="email"><a [matTooltip]="dataSource.expert.email"
                              href="mailto:{{dataSource.expert.email}}"> {{dataSource.expert.email}}</a></p>
                          <p class="phone">{{dataSource.expert.mobileNumber}}</p>
                          <div class="assigned-on">
                            <label>{{ "expert.Assignedon" | translate }}</label>
                            <p>{{dataSource.expert.assignedDate | date: "MMMM dd, y hh:mm aaa"}}</p>
                          </div>
                          <div class="assigned-on rejected" *ngIf="dataSource.assistanceRequestStatus == 3">
                            <label>{{ "matchmaking.Rejected on" | translate }}</label>
                            <p>{{dataSource.expert.respondDate | date: "MMMM dd, y hh:mm aaa"}}</p>
                          </div>

                        </div>
                        <div class="col-12 text-center assigned-btn-block">
                          <button mat-stroked-button class="btn assigned-btn"
                            [matTooltip]="'matchmaking.Reassign another Expert' | translate" color="primary"
                            [class.loading-btn]="loading" [disabled]="loading" (click)="assignExpert(dataSource)">
                            <span> {{ "matchmaking.Reassign another Expert" | translate}}</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="first-card one-card project-details profile border-raduis-bottom-none mb-0"
                    *ngIf="dataSource.assistanceRequestStatus == assistanceRequestStatusEnum.FBRejected">
                    <div class="row">
                      <div class="col-12 text-center assigned-stauts">
                        <span class="badge bg-danger">
                          {{ "experts.Declined" | translate}}
                        </span>
                      </div>

                      <div class="col-12 text-center declined-on">
                        <label>{{'AssistanceRequests.Declined on' | translate }}</label>
                        <p>{{dataSource.assistanceRequestRespondDate | date: "MMM dd, y hh:mm aaa" }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="first-card one-card project-details profile border-raduis-bottom-none mb-0"
                    *ngIf="dataSource.assistanceRequestStatus == assistanceRequestStatusEnum.ExpertDeclined">
                    <div class="row">
                      <div class="decision bg-white p-0">
                        <div class="row">
                          <div class="col-12 text-center assigned-stauts">
                            <span class="badge bg-danger">
                              {{ "experts.Declined" | translate}}
                            </span>
                          </div>
                          <div class="col-12 text-center assigned-title">
                            <h5>{{ "matchmaking.Assigned Expert" | translate }}</h5>
                          </div>
                          <div class="col-12 text-center expert-data">
                            <div class="img-cricle mt-4">
                              <div class="image">
                                <span>{{ dataSource.expert.name | shortName }}</span>
                              </div>
                            </div>
                            <p class="name">{{dataSource.expert.name}}</p>
                            <p class="email"><a [matTooltip]="dataSource.expert.email"
                                href="mailto:{{dataSource.expert.email}}"> {{dataSource.expert.email}}</a></p>
                            <p class="phone">{{dataSource.expert.mobileNumber}}</p>
                            <div class="assigned-on">
                              <label>{{ "expert.Assignedon" | translate }}</label>
                              <p>{{dataSource.expert.assignedDate | date: "MMMM dd, y hh:mm aaa"}}</p>
                            </div>
                          </div>
                          <div class="col-12 text-center declined-on">
                            <label>{{'AssistanceRequests.Declined on' | translate }}</label>
                            <p>{{dataSource.assistanceRequestRespondDate | date: "MMM dd, y hh:mm aaa" }}</p>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <div
                  *ngIf="dataSource.assistanceRequestStatus == assistanceRequestStatusEnum.FBRejected || dataSource.assistanceRequestStatus == assistanceRequestStatusEnum.ExpertDeclined"
                  class="kpis-history">
                  <div class="cards-container questionnaires">
                    <div class="first-card one-card project-details border-raduis-bottom-none p-0 pb-3 mb-0">
                      <mat-accordion class="example-headers-align">
                        <mat-expansion-panel class="border-radius-none" hideToggle>
                          <mat-expansion-panel-header>
                            <mat-panel-title class="align-items-center">
                              <div>
                                <small> {{ "AssistanceRequests.Reason of Decline" | translate}} </small>
                              </div>
                            </mat-panel-title>
                            <span class="material-icons open">
                              <svg xmlns="http://www.w3.org/2000/svg" width="8.002" height="15.002"
                                viewBox="0 0 8.002 15.002">
                                <path id="expand-contact-icon"
                                  d="M-8881-614.95l4-4.05,4,4.05-.938.949-3.062-3.1-3.062,3.1Zm0-13.1.938-.949,3.063,3.1,3.063-3.1.938.947-4,4.052Z"
                                  transform="translate(8881.002 629)" fill="#999" />
                              </svg>
                            </span>
                            <span class="material-icons close">
                              <svg xmlns="http://www.w3.org/2000/svg" width="8.001" height="15" viewBox="0 0 8.001 15"
                                class="ng-tns-c217-42">
                                <path id="expand-contact-icon"
                                  d="M-8881-618.05l.938-.95,3.063,3.1,3.061-3.1.94.95-4,4.05Zm0-6.9,4-4.052,4,4.052-.94.947-3.061-3.1-3.062,3.1Z"
                                  transform="translate(8881 629)" fill="#999"></path>
                              </svg>
                            </span>
                          </mat-expansion-panel-header>
                          <!-- end panel header -->

                          <div class="row pb-0 mt-3">
                            <div class="col-12">
                              <p class="history-record mb-0">
                                {{dataSource.reasonOfDecline}}
                              </p>
                            </div>
                          </div>

                        </mat-expansion-panel>
                      </mat-accordion>
                    </div>
                  </div>
                </div>
                <!----->
                <div *ngIf="dataSource.assistanceRequestStatus != assistanceRequestStatusEnum.FBRejected"
                  class="kpis-history">
                  <div class="cards-container questionnaires" *ngIf="dataSource.history.length">
                    <div class="first-card one-card project-details border-raduis-bottom-none p-0 mb-0">
                      <mat-accordion class="example-headers-align">
                        <mat-expansion-panel hideToggle>
                          <mat-expansion-panel-header>
                            <mat-panel-title class="align-items-center">
                              <div>
                                <small> {{ "matchmaking.Request Log / History" | translate}} </small>
                              </div>
                            </mat-panel-title>
                            <span class="material-icons open">
                              <svg xmlns="http://www.w3.org/2000/svg" width="8.002" height="15.002"
                                viewBox="0 0 8.002 15.002">
                                <path id="expand-contact-icon"
                                  d="M-8881-614.95l4-4.05,4,4.05-.938.949-3.062-3.1-3.062,3.1Zm0-13.1.938-.949,3.063,3.1,3.063-3.1.938.947-4,4.052Z"
                                  transform="translate(8881.002 629)" fill="#999" />
                              </svg>
                            </span>
                            <span class="material-icons close">
                              <svg xmlns="http://www.w3.org/2000/svg" width="8.001" height="15" viewBox="0 0 8.001 15"
                                class="ng-tns-c217-42">
                                <path id="expand-contact-icon"
                                  d="M-8881-618.05l.938-.95,3.063,3.1,3.061-3.1.94.95-4,4.05Zm0-6.9,4-4.052,4,4.052-.94.947-3.061-3.1-3.062,3.1Z"
                                  transform="translate(8881 629)" fill="#999"></path>
                              </svg>
                            </span>
                          </mat-expansion-panel-header>
                          <!-- end panel header -->

                          <ng-container *ngFor="let record of dataSource.history; let x = index">
                            <div class="row pb-0 mt-3">
                              <div class="col-12">
                                <p class="history-record mb-0">
                                  {{ "matchmaking.This request" | translate}}
                                  <span *ngIf="record.status == 2"> {{ "matchmaking.assigned to an" | translate}}</span>
                                  <span *ngIf="record.status == 5"> {{ "matchmaking.reassigned to an" |
                                    translate}}</span>
                                  <span *ngIf="record.status == 3"> {{ "matchmaking.opened as a case by" |
                                    translate}}</span>
                                  <span *ngIf="record.status == 4"> {{ "matchmaking.declined by" | translate}}</span>
                                  <span *ngIf="record.status == 6"> {{ "matchmaking.withdrawn by" | translate}}</span>

                                  <span *ngIf="record.status == 6" class="history-bold"> {{record.createdBy}}</span>
                                  <span *ngIf="record.status != 6" class="history-bold"> {{record.expert}}</span>
                                  {{ "matchmaking.on" | translate}}
                                  <span class="history-bold">{{record.transactionDate}}</span>
                                </p>
                              </div>
                            </div>
                            <hr [hidden]="x == dataSource.history.length - 1">
                          </ng-container>

                        </mat-expansion-panel>
                      </mat-accordion>
                    </div>
                  </div>
                </div>
              </ng-container>
              <ng-template #elseDiv>
                <div class="cards-container en-r-decision">
                  <div class="first-card one-card project-details profile mb-0">
                    <div class="row">
                      <div class="col-12 text-center assigned-stauts mb-0">
                        <span class="badge bg-primary">{{ "AssistanceRequests.Waiting Enterprise Application" |translate
                          }}</span>
                      </div>
                    </div>
                    <div class="decision bg-white">
                      <div class="row">
                        <div class="col-12 text-center">
                          <img class="img-fluid" src="../../../assets/images/application-illustration.png" alt="">
                          <h4>{{ "AssistanceRequests.Enterprise did not submit the application yet" | translate }}</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </div>
            <div class="col-lg-3" *ngIf="casesView">
              <div class="cards-container en-r-decision">
                <div class="first-card one-card project-details profile mb-0">
                  <div class="row mb-0 mt-0">
                    <div class="col-12 assigned-stauts casesView">
                      <div class="assigned-stauts-header">
                        <label>Case ID: <span>#{{dataSource.id}}</span></label>
                        <div>
                          <span *ngIf="dataSource?.status == assistanceRequestStatusEnum.NewCase"
                            class="badge bg-success">
                            {{ "requestes.NewCase" | translate}}
                          </span>
                          <span *ngIf="dataSource?.status == assistanceRequestStatusEnum.ExpertAddedFeedback"
                            class="badge bg-primary">
                            {{ "requestes.Expert Feedbacked" | translate}}
                          </span>
                          <span *ngIf="dataSource?.status == assistanceRequestStatusEnum.EnterpriseAddedFeedback"
                            class="badge bg-warning">
                            {{ "AssistanceRequests.Ready to close" | translate}}
                          </span>
                          <span
                            *ngIf="dataSource?.status == assistanceRequestStatusEnum.FocalPointAddedFeedbachAndClose"
                            class="badge bg-default">
                            {{ "AssistanceRequests.Closed" | translate}}
                          </span>
                        </div>

                      </div>
                    </div>
                    <div class="col-12 text-center assigned-title">
                      <h5>{{ "expert.Feedbacks" | translate }}</h5>
                    </div>
                  </div>
                  <div class="decision bg-white p-0">
                    <mat-accordion class="feedback-block">
                      <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                        <mat-expansion-panel-header>
                          <mat-panel-title>
                            {{'general.Expert' | translate}}
                          </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div *ngIf="dataSource.expertFeedback;else ExpertNoData">
                          <div class="d-flex align-items-center expert-name">
                            <div class="img-cricle">
                              <div class="image">
                                <span>{{ dataSource.expertName | shortName }}</span>
                              </div>
                              <div class="image-label">
                                {{dataSource.expertName}}
                              </div>
                            </div>
                          </div>
                          <label>{{'requestes.Feedback on' | translate}}</label>
                          <p>{{dataSource.expertFeedback.feedbackDate | date: "MMMM dd, y hh:mm aaa"}}</p>
                          <h6>{{'expert.AddressedProblem' | translate}}</h6>
                          <div class="feedback-p"
                            [innerHTML]="dataSource.expertFeedback.addressedProblemByExpert | sanitizeHtml"></div>
                          <h6>{{'expert.SummaryActions' | translate}}</h6>
                          <div class="feedback-p"
                            [innerHTML]="dataSource.expertFeedback.summaryOfActionsByExpert | sanitizeHtml"></div>
                          <h6>{{'expert.Recommendations' | translate}}</h6>
                          <div class="feedback-p"
                            [innerHTML]="dataSource.expertFeedback.recommendationsByExpert | sanitizeHtml"></div>
                          <ng-container
                            *ngIf="dataSource.expertFeedback.attachments && dataSource.expertFeedback.attachments.length">
                            <h6>{{'expert.Attachments' | translate}}</h6>
                            <div class="mt-3 mb-2">
                              <app-files-viewer [files]='dataSource.expertFeedback.attachments'></app-files-viewer>
                            </div>
                          </ng-container>
                        </div>
                        <ng-template #ExpertNoData>
                          <div class="decision p-0 bg-white mt-2">
                            <div class="row">
                              <div class="col-12 text-center">
                                <img class="img-fluid" src="../../../assets/images/no-feedback-illustration.png" alt="">
                              </div>
                              <div class="col-12 text-center no-feedback">
                                <h4>{{'expert.nofeedback' | translate}}</h4>
                                <!-- <p>Add your feedback on application answers per grouped question, then click the
                                  button
                                  below to add your final feedback.</p> -->
                              </div>
                            </div>
                          </div>
                        </ng-template>
                      </mat-expansion-panel>
                      <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                        <mat-expansion-panel-header>
                          <mat-panel-title>
                            {{'general.Enterprise' | translate}}
                          </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div *ngIf="dataSource.enterpriseFeedback;else EnterpriseNoData">
                          <label>{{'requestes.Feedback on' | translate}}</label>
                          <p>{{dataSource.enterpriseFeedback.feedbackDate | date: "MMMM dd, y hh:mm aaa"}}</p>
                          <h6>{{'requestes.Feedback' | translate}}</h6>
                          <div class="feedback-p" [innerHTML]="dataSource.enterpriseFeedback.text | sanitizeHtml"></div>
                        </div>
                        <ng-template #EnterpriseNoData>
                          <div class="decision p-0 bg-white mt-2">
                            <div class="row">
                              <div class="col-12 text-center">
                                <img class="img-fluid" src="../../../assets/images/no-feedback-illustration.png" alt="">
                              </div>
                              <div class="col-12 text-center no-feedback">
                                <h4>{{'expert.nofeedback' | translate}}</h4>
                                <!-- <p>Add your feedback on application answers per grouped question, then click the
                                  button
                                  below to add your final feedback.</p> -->
                              </div>
                            </div>
                          </div>
                        </ng-template>
                      </mat-expansion-panel>
                      <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                        <mat-expansion-panel-header>
                          <mat-panel-title>
                            {{'general.UNIDO' | translate}}
                          </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div *ngIf="dataSource.focalpointFeedback;else UNIDONoData">
                          <label>{{'requestes.Feedback on' | translate}}</label>
                          <p>{{dataSource.focalpointFeedback.feedbackDate | date: "MMMM dd, y hh:mm aaa"}}</p>
                          <h6>{{'requestes.Feedback' | translate}}</h6>
                          <div class="feedback-p" [innerHTML]="dataSource.focalpointFeedback.text | sanitizeHtml"></div>
                        </div>
                        <ng-template #UNIDONoData>
                          <div class="decision p-0 bg-white mt-2">
                            <div class="row">
                              <div class="col-12 text-center">
                                <img class="img-fluid" src="../../../assets/images/no-feedback-illustration.png" alt="">
                              </div>
                              <div class="col-12 text-center no-feedback">
                                <h4>{{'expert.nofeedback' | translate}}</h4>
                                <!-- <p>Add your feedback on application answers per grouped question, then click the
                                  button
                                  below to add your final feedback.</p> -->
                              </div>
                              <div class="col-12 text-center ">
                                <button mat-raised-button [disabled]="!canAddFinalFeedback || loading" class="btn"
                                  (click)="addFinalFeedback()" color="primary" [class.loading-btn]="loading">
                                  <span>{{'requestes.Add my final Feedback' | translate}}</span>
                                </button>
                              </div>
                            </div>
                          </div>
                        </ng-template>
                      </mat-expansion-panel>
                    </mat-accordion>
                  </div>
                </div>
              </div>
              <div class="kpis-history mt-2">
                <div class="cards-container questionnaires" *ngIf="dataSource.history.length">
                  <mat-accordion class="example-headers-align">
                    <mat-expansion-panel class="mb-3" hideToggle>
                      <mat-expansion-panel-header>
                        <mat-panel-title class="align-items-center">
                          <div>
                            <small> {{ "matchmaking.Request Log / History" | translate}} </small>
                          </div>
                        </mat-panel-title>
                        <span class="material-icons open">
                          <svg xmlns="http://www.w3.org/2000/svg" width="8.002" height="15.002"
                            viewBox="0 0 8.002 15.002">
                            <path id="expand-contact-icon"
                              d="M-8881-614.95l4-4.05,4,4.05-.938.949-3.062-3.1-3.062,3.1Zm0-13.1.938-.949,3.063,3.1,3.063-3.1.938.947-4,4.052Z"
                              transform="translate(8881.002 629)" fill="#999" />
                          </svg>
                        </span>
                        <span class="material-icons close">
                          <svg xmlns="http://www.w3.org/2000/svg" width="8.001" height="15" viewBox="0 0 8.001 15"
                            class="ng-tns-c217-42">
                            <path id="expand-contact-icon"
                              d="M-8881-618.05l.938-.95,3.063,3.1,3.061-3.1.94.95-4,4.05Zm0-6.9,4-4.052,4,4.052-.94.947-3.061-3.1-3.062,3.1Z"
                              transform="translate(8881 629)" fill="#999"></path>
                          </svg>
                        </span>
                      </mat-expansion-panel-header>
                      <!-- end panel header -->

                      <ng-container *ngFor="let record of dataSource.history; let x = index">
                        <div class="row pb-0 mt-3">
                          <div class="col-12">
                            <p class="history-record">
                              <span *ngIf="record.status == 3">{{ "matchmaking.This request" | translate}}
                                {{'requestes.opened as a Case on' | translate}}</span>
                              <span *ngIf="record.status == 7">{{'AssistanceRequests.Application Feedback Added by
                                Expert' | translate}}</span>
                              <span *ngIf="record.status == 8">{{'AssistanceRequests.Application Feedback Updated by
                                Expert' | translate}}</span>
                              <span *ngIf="record.status == 9">{{'requestes.Captured Image Uploaded by' |
                                translate}}</span>
                              <span *ngIf="record.status == 10">{{'requestes.Captured Image Removed by' | translate
                                }}</span>
                              <span *ngIf="record.status == 11">{{'requestes.Expert Final Feedback Added By' |
                                translate}}</span>
                              <span *ngIf="record.status == 12">{{'requestes.Enterprise Final Feedback Added By' |
                                translate}}</span>
                              <span *ngIf="record.status == 13">{{'requestes.UNIDO Final Feedback Added By' |
                                translate}}</span>
                              <span *ngIf="record.status == 14">{{'AssistanceRequests.Captured Image Title Updated By' |
                                translate}}</span>

                              <span class="history-bold"> {{record.createdBy}}</span>
                              {{ "matchmaking.on" | translate}}
                              <span class="history-bold">{{record.transactionDate}}</span>
                            </p>
                          </div>
                        </div>
                        <hr [hidden]="x == dataSource.history.length - 1">
                      </ng-container>

                    </mat-expansion-panel>

                  </mat-accordion>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ng-template #dataEmpty>
    <div class="data-empty">
      <p>{{ "expert.NoDataFound" | translate }}</p>
    </div>
  </ng-template>
</div>
